"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _reactRouterDom = require("react-router-dom");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

/**
 * Renders an internal link in the app.
 *
 * @param {string} to A route to link to.
 *
 * @example
 * <Link to="/about-us">About Us</Link>
 */
var Link = (0, _styledComponents["default"])(_reactRouterDom.Link).withConfig({
  displayName: "Link",
  componentId: "sc-1cseerm-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " box-sizing:border-box;"], _styledSystem.color, _styledSystem.width, _styledSystem.space, _styledSystem.height, _styledSystem.fontSize, _styledSystem.fontFamily, _styledSystem.borderRadius, _styledSystem.borders, _styledSystem.display, _styledSystem.maxWidth, _styledSystem.minWidth, _styledSystem.maxHeight, _styledSystem.minHeight, _styledSystem.size, _styledSystem.position, _styledSystem.zIndex, _styledSystem.top, _styledSystem.right, _styledSystem.left, _styledSystem.bottom);
var _default = Link;
exports["default"] = _default;